<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    value: {
      default: null,
    },
    id: {
      type: String,
    },
    textAreaClass: {
      type: String,
      default: '',
    },
    rows: {
      type: String,
      default: '5',
    },
    maxlength: {
      type: Number,
      default: 200000000000,
    },
    textAreaStyle: {
      type: String,
      default: '',
    },
    disable: {
      type: Boolean,
      default: false,
    },
    classes: {
      type: String,
      default: '',
    },
    showTitle: {
      type: Boolean,
      default: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    showError: {
      type: Boolean,
      default: false,
    },
    errortext: {
      type: String,
      default: '',
    },
  },
  computed: {
    inputVal: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
  methods: {
    focused() {
      this.$emit('focused')
    },
  },
}
</script>

<template>
  <div>
    <div class="d-flex" :class="textAreaClass">
      <label class="labelStyle" v-if="showTitle" :style="title.length > 12 ? { whiteSpace: 'none' } : { whiteSpace: 'nowrap' }">{{ title }}</label>
      <textarea
        :class="showError ? `errorStyle` : `inputStyle`"
        autocomplete="off"
        :disabled="disable"
        :id="id"
        :maxlength="maxlength"
        class="area"
        v-model="inputVal"
        :placeholder="placeholder"
        name="message"
        :rows="rows"
        @focus="focused()"
        :style="required ? 'border-right: 5px solid #fe5e61;' : ''"
        :required="required"
      ></textarea>
    </div>
    <div v-if="showError" class="errorClass">{{ errortext }}</div>
    <!-- <div class="limitation" v-if="inputVal.length === 250">مجاز به تایپ بیش از 250 حرف نمی باشید</div> -->
  </div>
</template>

<style lang="scss" scoped>
.errorStyle {
  line-height: 17px;
  width: 100%;
  color: #74788d;
  background: #ffffff;
  border: 1px solid #fe5e61 !important;
  padding: 6px 10px;
  box-sizing: border-box;
}
.errorClass {
  margin-right: 100px;
  font-size: 10px;
  color: #fe5e61;
}
.limitation {
  font-size: 12px;
  color: red;
}
.label {
  display: flex;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 21px;
  text-align: right;
  color: #444444;
  margin-bottom: 0;
  justify-content: flex-start;
  align-items: center;
}
::v-deep .form-group {
  display: flex;
}
.area:focus {
  outline: none;
}
.labelStyle {
  align-self: center;
  min-width: 92px;
  max-width: 90px;
  margin-left: 10px;
  display: table;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  text-align: right;
  color: #444444;
  justify-content: flex-start;
  align-items: center;
}
.area:focus::placeholder {
  color: transparent;
}
.area {
  padding: 10px 15px;
  width: 100%;
  background: #ffffff;
  border: 1px solid #ced4da;
  box-sizing: border-box;
  border-radius: 4px;
}
</style>
